
import request from '@/utils/request';
// 获取公司抽奖奖品
export function getLotteryPrizeApi(data:any) {
    return request({
      url: '/convention-center/appConvention/lottery/getLotteryPrize',
      method: 'post',
      data
    });
}
// 获取公司抽奖名单
export function getLotteryListApi(data:any) {
    return request({
      url: '/convention-center/appConvention/lottery/getLotteryList',
      method: 'post',
      data
    });
}
// 获取部门列表
export function getDeparmentListApi() {
    return request({
      url: '/convention-center/appConvention/lottery/getDeparmentList',
      method: 'post',
    });
}
// 禅道4111 邮件退订功能
export function promotionUnsubscribeApi(email:any,type:any) {
  return request({
    url: '/reminder-center/reminder/email/promotionUnsubscribe',
    method: 'get',
    params:{email,type}
  });
}
// 发送邮件类型下拉
export function getNewsTypeWithUnsubscribeApi(email:any) {
  return request({
    url: `/reminder-center/reminder/newsSendType/getNewsTypeWithUnsubscribe`,
    method: 'post',
    data:{email}
  });
}
